import { Button, Dialog, DialogActions, DialogContent, Divider, Stack } from '@mui/material';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';

interface props {
  open: boolean;
  onClose: VoidFunction;
}

const AlertDialog = ({ open, onClose }: props) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Header variant="dialog" title={'Alert'} onClose={onClose} />
      <Divider />
      <DialogContent>
        <Stack mt={2} mb={2}>
          {Strings.common.actionCanNotBePerformed}
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { AlertDialog };
